/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
import { makeHandle as e } from "./handleUtils.js";
function t(e) {
  return e && ("function" == typeof e.on || "function" == typeof e.addEventListener);
}
function r(r, n, o) {
  if (!t(r)) throw new TypeError("target is not a Evented or EventTarget object");
  if ("on" in r) return r.on(n, o);
  if (Array.isArray(n)) {
    const t = n.slice();
    for (const e of t) r.addEventListener(e, o);
    return e(() => {
      for (const e of t) r.removeEventListener(e, o);
    });
  }
  return r.addEventListener(n, o), e(() => r.removeEventListener(n, o));
}
function n(e, n, o) {
  if (!t(e)) throw new TypeError("target is not a Evented or EventTarget object");
  if ("once" in e) return e.once(n, o);
  const i = r(e, n, t => {
    i.remove(), o.call(e, t);
  });
  return i;
}
function o(e, t, n) {
  let o = !1;
  const i = r(e, t, t => {
    o || n.call(e, t);
  });
  return {
    resume() {
      o = !1;
    },
    pause() {
      o = !0;
    },
    remove() {
      i.remove();
    }
  };
}
const i = {
  Win: "Meta",
  Scroll: "ScrollLock",
  Spacebar: " ",
  Down: "ArrowDown",
  Left: "ArrowLeft",
  Right: "ArrowRight",
  Up: "ArrowUp",
  Del: "Delete",
  Apps: "ContextMenu",
  Esc: "Escape",
  Multiply: "*",
  Add: "+",
  Subtract: "-",
  Decimal: ".",
  Divide: "/"
};
function c({
  key: e
}) {
  return i[e] || e;
}
export { c as eventKey, i as ieKeyNormalizationMap, t as isEventTarget, r as on, n as once, o as pausable };